<div [class]="badgeClass()">
  <ng-content></ng-content>
</div>
